import { SVGProps } from "react"

const MapBranches = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="M16.58.045a.318.318 0 0 0-.316-.005l-4.96 2.744L6.344.041a.318.318 0 0 0-.309 0L.921 2.87a.32.32 0 0 0-.165.279v12.513a.32.32 0 0 0 .474.28l4.96-2.745 4.96 2.745a.318.318 0 0 0 .309 0l5.114-2.83a.32.32 0 0 0 .165-.28V.32a.32.32 0 0 0-.157-.275Zm-10.71 12.6L1.395 15.12V3.338L5.87.862v11.782Zm5.115 2.476-4.476-2.477V.862l4.476 2.476v11.783Zm5.114-2.477-4.475 2.476V3.338L16.099.862v11.782Z" />
      <path
        fillOpacity={0.2}
        d="M16.58.045a.318.318 0 0 0-.316-.005l-4.96 2.744L6.344.041a.318.318 0 0 0-.309 0L.921 2.87a.32.32 0 0 0-.165.279v12.513a.32.32 0 0 0 .474.28l4.96-2.745 4.96 2.745a.318.318 0 0 0 .309 0l5.114-2.83a.32.32 0 0 0 .165-.28V.32a.32.32 0 0 0-.157-.275Zm-10.71 12.6L1.395 15.12V3.338L5.87.862v11.782Zm5.115 2.476-4.476-2.477V.862l4.476 2.476v11.783Zm5.114-2.477-4.475 2.476V3.338L16.099.862v11.782Z"
      />
      <path
        fillOpacity={0.2}
        d="M16.58.045a.318.318 0 0 0-.316-.005l-4.96 2.744L6.344.041a.318.318 0 0 0-.309 0L.921 2.87a.32.32 0 0 0-.165.279v12.513a.32.32 0 0 0 .474.28l4.96-2.745 4.96 2.745a.318.318 0 0 0 .309 0l5.114-2.83a.32.32 0 0 0 .165-.28V.32a.32.32 0 0 0-.157-.275Zm-10.71 12.6L1.395 15.12V3.338L5.87.862v11.782Zm5.115 2.476-4.476-2.477V.862l4.476 2.476v11.783Zm5.114-2.477-4.475 2.476V3.338L16.099.862v11.782Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.75 0h16v16h-16z" />
      </clipPath>
    </defs>
  </svg>
)
export default MapBranches
